module.exports = __webpack_public_path__ + "./docs/img/big-icon-root.2ec54478f16b7b9c5871fefc3cd9b245.svg";